(function () {
    /*jshint camelcase: false */
    'use strict';

    angular
        .module('josdaviApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$rootScope', '$http', '$localStorage', 'Base64'];

    function AuthServerProvider($rootScope, $http, $localStorage, Base64) {
        var service = {
            getToken: getToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken() {
            return $localStorage.authenticationToken;
        }

        function login(credentials) {
            var data = 'username=' + encodeURIComponent(credentials.username) + '&password=' +
                encodeURIComponent(credentials.password) + '&grant_type=password&scope=read%20write&' +
                'client_secret=76db325a111fa4e60985bf96fec85d6de&client_id=sms-api-web';

            return $http.post('oauth/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'application/json',
                    'Authorization': 'Basic ' + Base64.encode('sms-api-web' + ':' + '76db325a111fa4e60985bf96fec85d6de')
                }
            }).success(authSucess);

            function authSucess(response) {
                var expiredAt = new Date();
                expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                response.expires_at = expiredAt.getTime();
                $localStorage.authenticationToken = response;
                $rootScope.$broadcast('onLoginSuccess');
                return response;
            }
        }

        function logout() {
            $http.post('api/logout').then(function () {
                delete $localStorage.authenticationToken;
                $rootScope.$broadcast('onLogoutSuccess');
            });
        }
    }
})();
